import { Reducer } from "redux";

import { NotesTemplateJsonResp } from "../models/Api/Notes";
import { DisciplineNotesTemplateDispatchTypes } from "../models/DispatchTypes/Notes";
import { GetDisciplineNotesTemplateActionDispatchTypes } from "../constants/Notes";

export const initialState: NotesTemplateJsonResp = {
  loading: false,
  response: {
    noteTemplateId: -1,
    templateName: "",
    templateJson: "",
    templateCategoryId: "",
    categoryName: "",
  },
};

const DisciplineNotesTemplateJsonReducer: Reducer<
  NotesTemplateJsonResp,
  DisciplineNotesTemplateDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case GetDisciplineNotesTemplateActionDispatchTypes.DISCIPLINE_NOTES_TEMPLATE_JSON_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case GetDisciplineNotesTemplateActionDispatchTypes.DISCIPLINE_NOTES_TEMPLATE_JSON_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case GetDisciplineNotesTemplateActionDispatchTypes.DISCIPLINE_NOTES_TEMPLATE_JSON_RESET: {
      return initialState;
    }
  }
  return state;
};

export default DisciplineNotesTemplateJsonReducer;
